module.exports = __webpack_public_path__ + "static/media/bigbangth.b5ad72c7.jpg";